export const TRANSPORT_BASE_KEY = 'tour-transport';

export const transportApiQueryKeys = {
  byTourId: (tourId: string) => [TRANSPORT_BASE_KEY, tourId] as const,
};
